import EnvChecker from "@/src/util/class/EnvChecker";
import { APP_ONE_LINK } from '../enum/Constants';
import { firebaseInit } from './firebase';
import { isIOS, openDialog } from './utils';
import '../../public/static/css/reset.css';
import '../../public/static/css/base.css';
import '../../public/static/css/common.css';
import '../../public/static/css/etc.css';
const goToWeb = () => {
    window.location.href = '/';
};
const goAppLink = () => {
    if (isIOS()) {
        openDialog('iOS 앱은 준비중입니다.', goToWeb);
    }
    else {
        const search = window.location.search || '?pid=""';
        window.open(`${APP_ONE_LINK}${search}&is_retargeting=true`, '_self');
    }
};
const handleTagChange = (e) => {
    if (!e.target) {
        return;
    }
    const target = e.target;
    if (target.dataset.index !== undefined) {
        const index = Number(target.dataset.index);
        const other = index === 0 ? 1 : 0;
        const list = document.getElementsByClassName('promotion-box');
        if (list[index]) {
            list[index].style.display = 'block';
        }
        if (list[other]) {
            list[other].style.display = 'none';
        }
    }
};
const initialize = () => {
    if (!EnvChecker.isMobile()) {
        window.location.href = 'join_pc.html';
        return;
    }
    firebaseInit();
    const btn = document.getElementById('download-btn');
    if (btn) {
        btn.addEventListener('click', goAppLink);
    }
    document.addEventListener('click', handleTagChange);
};
initialize();
